import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48042330")

_pushScopeId("data-v-48042330")
const _hoisted_1 = { class: "ordercreate" }
const _hoisted_2 = { class: "ordercreate__form" }
const _hoisted_3 = { class: "form__header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "form__title" }, "Отправка заявки", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "form__description" }, "Укажите данные для получения большей информации", -1)
const _hoisted_6 = { class: "form__actions" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Отправить данные ")
const _hoisted_8 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Главная", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("h2", { class: "title margin" }, "Скоро", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Создание заказа", -1)
const _hoisted_11 = {
  class: "OrderTypeSelector",
  style: {"display":"flex","align-items":"center","justify-content":"flex-start"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_s_modal = _resolveComponent("s-modal")!
  const _component_order_types = _resolveComponent("order-types")!
  const _component_s_switch = _resolveComponent("s-switch")!
  const _component_ftl_order_template = _resolveComponent("ftl-order-template")!
  const _component_ltl_template = _resolveComponent("ltl-template")!
  const _component_express_template = _resolveComponent("express-template")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.form_state.is_opened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 0,
          onClose: _ctx.closeForm
        }, {
          body: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_icon_close, {
                  class: "form__close",
                  onClick: _ctx.closeForm
                }, null, 8, ["onClick"])
              ]),
              _hoisted_5,
              _createVNode(_component_s_input, {
                value: _ctx.form_state.name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form_state.name = $event)),
                "is-invalid": _ctx.form_state$.name.$error,
                placeholder: "Имя и Фамилия"
              }, null, 8, ["value", "is-invalid"]),
              _createVNode(_component_s_input, {
                value: _ctx.form_state.phone_number,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form_state.phone_number = $event)),
                "is-invalid": _ctx.form_state$.phone_number.$error,
                placeholder: "Телефон для связи",
                maska: {
                            mask: '+# (###) ###-##-##',
                        }
              }, null, 8, ["value", "is-invalid", "maska"]),
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_s_button, {
                  class: "purple",
                  loading: _ctx.form_state.is_loading,
                  onClick: _ctx.submitForm
                }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (!_ctx.CurrentOrderType)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _hoisted_8,
          _createVNode(_component_order_types, {
            "order-types": _ctx.ORDER_TYPES,
            onOpenForm: _ctx.onOpenForm
          }, null, 8, ["order-types", "onOpenForm"]),
          _hoisted_9,
          _createVNode(_component_order_types, { "order-types": _ctx.ORDER_TYPES_SOON }, null, 8, ["order-types"])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isFTL || _ctx.isLTL || _ctx.isEXPRESS)
      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_s_switch, {
              theme: _ctx.isFTL ? 'red' : _ctx.isLTL ? 'primary' : 'blue',
              value: _ctx.CurrentOrderType,
              options: _ctx.ORDER_TYPE_OPTIONS,
              onChange: _ctx.setOrderType
            }, null, 8, ["theme", "value", "options", "onChange"])
          ]),
          (_ctx.isFTL)
            ? (_openBlock(), _createBlock(_component_ftl_order_template, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.isLTL)
            ? (_openBlock(), _createBlock(_component_ltl_template, { key: 1 }))
            : _createCommentVNode("", true),
          (_ctx.isEXPRESS)
            ? (_openBlock(), _createBlock(_component_express_template, { key: 2 }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
})